export default "__VITE_ASSET__DBPSU7ci__"